import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

//Mốc 00:00 hôm nay (unix) - mặc định lọc theo ngày hiện tại
const todayUnix = Math.floor(new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000);

const employeeEvaluation = createSlice({
	name: "employeeEvaluation",
	initialState: {
		loading: false,
		error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
			evaluateDate : todayUnix,
			status : 'fail'
		},
		items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			if (objIndex !== -1) {
				state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			}
			return state;
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const employeeEvaluationActions = employeeEvaluation.actions;
//Reducers
export const employeeEvaluationReducer = employeeEvaluation.reducer;
//Selectors
export const employeeEvaluationItemsSelector = (state) => state.employeeEvaluation.items;
export const employeeEvaluationLoadingSelector = (state) => state.employeeEvaluation.loading;
export const employeeEvaluationErrorSelector = (state) => state.employeeEvaluation.error;
export const employeeEvaluationFilterSelector = (state) => state.employeeEvaluation.filter;
export const employeeEvaluationPaginationSelector = (state) => state.employeeEvaluation.pagination;
